// NOTE: this file is for constants that rely on imports from nc-components and so cannot be placed in nc-utils.
// Any constants that do not rely on nc-components imports should be placed in nc-utils.
import React, { ReactNode } from 'react';

import {
  genericErrorMessage,
  invalidDateErrorMessage,
  PaymentErrorTypeT,
} from '@consumer-frontend/nc-utils';

import { NcSupportNumberLink } from '../lib/NcSupportNumberLink';

export const MAKE_PAYMENT_ERRORS_MAP: Record<PaymentErrorTypeT, ReactNode> = {
  immediate_payment_failure: (
    <>
      <p className="alert-heading">Debit card payment couldn&#39;t be processed.</p>
      Change your payment method, or call Customer Support at <NcSupportNumberLink />.
    </>
  ),
  invalid_amount: 'Amount is invalid.',
  // For CFPB we show the message from the API response to the customer, but this field needs to be defined here so it's
  // not treated as an unsupported error type.
  invalid_cfpb_date: '',
  invalid_date: invalidDateErrorMessage,
  server_error: genericErrorMessage,
  validation_error_date: invalidDateErrorMessage,
  // NOTE: unsupported error_types are in the format: `validation_error_<field_name>`
};

export const standardErrorHeader = 'Something went wrong.';
export const standardErrorMessage = (
  <>
    Refresh the page and try again. If the problem persists, call our Customer Support Team at <NcSupportNumberLink />.
  </>
);

export const scheduledPaymentsErrorHeader = "We couldn't load your estimates.";
